webpackJsonp([117206707316740],{

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ahptuslogo.cea6e305.jpg";

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/nuclyaa.f98a57a6.png";

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/nuclyalogo.7990b95d.jpg";

/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sala.d861392c.jpg";

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _pic = __webpack_require__(77);
	
	var _pic2 = _interopRequireDefault(_pic);
	
	var _sala = __webpack_require__(541);
	
	var _sala2 = _interopRequireDefault(_sala);
	
	var _ahptuslogo = __webpack_require__(527);
	
	var _ahptuslogo2 = _interopRequireDefault(_ahptuslogo);
	
	var _nuclyalogo = __webpack_require__(533);
	
	var _nuclyalogo2 = _interopRequireDefault(_nuclyalogo);
	
	var _nuclyaa = __webpack_require__(532);
	
	var _nuclyaa2 = _interopRequireDefault(_nuclyaa);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Generic = function Generic(props) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement(
	                'title',
	                null,
	                'AHPTUS'
	            ),
	            _react2.default.createElement('meta', { name: 'description', content: 'Generic Page' })
	        ),
	        _react2.default.createElement(
	            'div',
	            { id: 'main', className: 'alt' },
	            _react2.default.createElement(
	                'section',
	                { id: 'one' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner' },
	                    _react2.default.createElement(
	                        'header',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'image midlogo' },
	                            _react2.default.createElement('img', { src: _ahptuslogo2.default, alt: '' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'image main' },
	                        _react2.default.createElement('img', { src: _sala2.default, alt: '' })
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Tendo iniciado a sua atividade como entidade formadora orientada para pequenas e m\xE9dias empresas, a Ahptus hoje define-se tamb\xE9m como uma empresa de consultoria que responde \xE0s necessidades de apoio \xE0 gest\xE3o de neg\xF3cios das mais diversas \xE1reas. Pretendemos ser a empresa de refer\xEAncia no desenvolvimento e melhoria de compet\xEAncias e desempenho dos nossos clientes. As \xE1reas de interven\xE7\xE3o da Ahptus est\xE3o distribu\xEDdas por quase todos os sectores de atividade, tais como: Sa\xFAde, Servi\xE7os Com\xE9rcio, Log\xEDstica, Industria Alimentar, Industria T\xEAxtil, Industria El\xE9ctrica, Consultoria, Restaura\xE7\xE3o, Constru\xE7\xE3o Civil, Contabilidade e Gest\xE3o, Metalomec\xE2nica, Importa\xE7\xE3o e Exporta\xE7\xE3o, Montagem El\xE9ctricas e Qu\xEDmica.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'A Ahptus demonstra uma preocupa\xE7\xE3o constante com a melhoria cont\xEDnua da qualidade dos servi\xE7os prestados aos seus clientes e a realiza\xE7\xE3o profissional dos seus colaboradores.'
	                    ),
	                    _react2.default.createElement(
	                        'center',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://www.ahptus.com', className: 'button' },
	                            'Saber mais'
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'scroll-down__container' },
	            _react2.default.createElement(
	                'section',
	                { id: 'scrollDown', className: 'scrolld' },
	                _react2.default.createElement(
	                    'a',
	                    { href: '#two' },
	                    _react2.default.createElement('span', null)
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { id: 'main', className: 'alt' },
	            _react2.default.createElement(
	                'section',
	                { id: 'two' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner' },
	                    _react2.default.createElement(
	                        'header',
	                        { className: 'major' },
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'image midlogo' },
	                            _react2.default.createElement('img', { src: _nuclyalogo2.default, alt: '' })
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'span',
	                        { className: 'image main' },
	                        _react2.default.createElement('img', { src: _nuclyaa2.default, alt: '' })
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Na Nuclya pensamos a Sa\xFAde das pessoas numa perspetiva integrada como defende a metodologia 3\xB4H. Na nossa opini\xE3o, s\xF3 uma vis\xE3o global sobre a perspetiva f\xEDsica, mental e emocional da pessoa nos dar\xE1 o bem estar completo.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        ' S\xE3o assim 3 as \xE1reas que temos de trabalhar para atingir a nossa vis\xE3o de bem estar: a sa\xFAde, a nutri\xE7\xE3o e atividade f\xEDsica. Aliada a estas \xE1reas, est\xE1 transversalmente a criatividade, o foco estrat\xE9gico, o esp\xEDrito de equipa e a abordagem \xE0 organiza\xE7\xE3o de sa\xFAde no sentido de tornar a experi\xEAncia do cliente \xFAnica.'
	                    ),
	                    _react2.default.createElement(
	                        'center',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'http://www.nuclya.com/', className: 'button' },
	                            'Saber mais'
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Generic;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-ahptus-js-9c7a2b3ca84b836fa8bc.js